import React from 'react';
import { Col, Row, Form } from 'react-bootstrap';
import { connect, useSelector } from 'react-redux';
import { AppRootState } from '../redux';

export const SettingsUserInfo = () => {
  const currentUser = useSelector((state: AppRootState) => state?.auth?.session?.user);

  return (
    <Row className='d-flex justify-content-between'>
      <Col md={4} sm={4}>
        <Form.Label>Full Name:</Form.Label>
        <Form.Control type='text' value={currentUser?.name || ''} disabled className='text-black-50' />
      </Col>
      <Col md={4} sm={4}>
        <Form.Label>Username:</Form.Label>
        <Form.Control type='text' value={currentUser?.Login || ''} disabled className='text-black-50' />
      </Col>
      <Col md={4} sm={4}>
        <Form.Label>Email Address:</Form.Label>
        <Form.Control type='text' value={currentUser?.email || ''} disabled className='text-black-50' />
      </Col>
    </Row>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export const ConnectedSettingsUserInfo = connect(mapStateToProps, mapDispatchToProps)(SettingsUserInfo);
